import { render, staticRenderFns } from "./EditModelosPage.vue?vue&type=template&id=ad1492ea"
import script from "./EditModelosPage.vue?vue&type=script&lang=js"
export * from "./EditModelosPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports